import React from 'react';
import { css } from 'react-emotion';

export const sideError = css({
  display: 'block',
  fontFamily: 'arial',
  fontSize: '.875rem',
  color: '#dc3545',
});

const FormGroup = ({ render }) => <div className="form-group">{render()}</div>;
const InputField = ({
  type = 'text',
  label,
  placeholder,
  help,
  field,
  form,
}) => {
  return (
    <FormGroup
      render={() => (
        <div>
          <label htmlFor={field.name}>{label}</label>
          <div>
            {type !== 'textarea' ? (
              <input
                type={type}
                className="form-control"
                aria-describedby={field.name}
                placeholder={placeholder}
                {...field}
              />
            ) : (
              <textarea
                className="form-control"
                aria-describedby={field.name}
                placeholder={placeholder}
                {...field}
              />
            )}
            {form.touched[field.name] &&
              form.errors[field.name] && (
                <div className={sideError}>{form.errors[field.name]}</div>
              )}
          </div>
          {help && <small className="form-text text-muted">{help}</small>}
        </div>
      )}
    />
  );
};

export default InputField;



// WEBPACK FOOTER //
// ./src/components/buttons/NewProjectButtons/InputField.js